import pagination from '../../utils/pagination'
import {
  REVIEWS_BATCH_DELETE_REQUEST, REVIEWS_BATCH_DELETE_SUCCESS, REVIEWS_BATCH_DELETE_FAILURE,
  REVIEWS_FETCH_MANY_REQUEST, REVIEWS_FETCH_MANY_SUCCESS, REVIEWS_FETCH_MANY_FAILURE,
  REVIEWS_FETCH_REQUEST, REVIEWS_FETCH_SUCCESS, REVIEWS_FETCH_FAILURE,
  REVIEWS_SAVE_REQUEST, REVIEWS_SAVE_SUCCESS, REVIEWS_SAVE_FAILURE,

  EMPTY_REVIEWS,
  CLEAR_ERRORS
} from './types'

export default {
  [REVIEWS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [REVIEWS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [REVIEWS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [REVIEWS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [REVIEWS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [REVIEWS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [REVIEWS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [REVIEWS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [REVIEWS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [REVIEWS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [REVIEWS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [REVIEWS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_REVIEWS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
